import { log } from './api';

declare global {
  interface Window {
    WorkmagicPixel?: (event: string, data: Record<string, unknown>) => void;
  }
}

/**
 * Submits a `checkout_started` event.
 *
 * @param orderId - Unique identifier representing that checkout
 */
function checkoutStarted(orderId: number): boolean {
  if (!window.WorkmagicPixel) {
    log('Workmagic', {
      event: 'checkout_started',
      status: 'not_sent',
      reason: 'Pixel not found',
      checkout: {
        token: orderId.toString(),
      },
    });
    return false;
  }

  const response = window.WorkmagicPixel('checkout_started', {
    checkout: {
      token: orderId.toString(),
    },
  });

  log('Workmagic', {
    event: 'checkout_started',
    status: 'sent',
    checkout: {
      token: orderId.toString(),
    },
    response,
  });

  return true;
}

export const workmagic = {
  checkoutStarted,
};
